import { render, staticRenderFns } from "./ClusterBadge.vue?vue&type=template&id=81a99ac2&scoped=true&"
import script from "./ClusterBadge.vue?vue&type=script&lang=js&"
export * from "./ClusterBadge.vue?vue&type=script&lang=js&"
import style0 from "./ClusterBadge.vue?vue&type=style&index=0&id=81a99ac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a99ac2",
  null
  
)

export default component.exports